async function SitesSave (addressindustryid, addressid, industryid, modifiedbyid, deleted) {

    //addressindustryid expected to be null every time (that's what we are making)
    if (
        addressid.length > 0 && 
        industryid.length > 0 && 
        modifiedbyid.length > 0 && 
        deleted.length > 0
    ) {

            let response;

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "70", 
                    "parameters": {
                        "@AddressIndustryId": addressindustryid,
                        "@AddressId": addressid,
                        "@IndustryId": industryid,
                        "@ModifiedById": modifiedbyid,
                        "@Deleted": deleted
                    },
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);

    }
}
 
export default SitesSave;